export const OPERATIONS_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'Dashboard', href: '/dashboard', icon: 'cilSpeedometer' },

  { slug: 'title', name: 'Operations' },
  { slug: 'link', name: 'Packing Batches', href: '/packingBatches', icon: 'cilPackage' },
  { slug: 'link', name: 'Barcodes', href: '/barcodes', icon: 'cilBarcode' },
  // { slug: 'link', name: 'Mark Returns', href: '/markreturn', icon: 'cilArrowRight' },
  // { slug: 'link', name: 'Stock Updates', href: '/stock', icon: 'cilGrid' },
  // { slug: 'link', name: 'Events', href: '/events', icon: 'cilCalendar' },

  { slug: 'title', name: 'CRM & Calls' },
  { slug: 'link', name: 'Call Log', href: '/call_log', icon: 'cilCallIncoming' },
  // { slug: 'link', name: 'Installments', href: '/installments', icon: 'cilCalendar' },

  { slug: 'title', name: 'Reports' },
  { slug: 'link', name: 'Sales Report', href: '/salesreport', icon: 'cilChartUp' },
  { slug: 'link', name: 'Department Report', href: '/departmentreport', icon: 'cilGrid' },

  { slug: 'title', name: 'Resources' },
  { slug: 'link', name: 'Info Center', href: '/info-center', icon: 'cilLibrary' },
  { slug: 'link', name: 'Private Notes', href: '/private-notes', icon: 'cilNote' },
]
